import styled from 'styled-components';
const TextCenter = styled.div `
  text-align: center;
  color: #fff;
`;
export const Container = styled(TextCenter) `
  position: relative;
  width: 100%;
  /* 大屏高度：如拍卖师里的大屏，高度百分百；纯大屏，如全屏中的 （最后一辆车 || 未开始 || 已结束），高度百分百，除此高度calc(100% - 0.48rem) */
  height: ${(props) => props.isAuctioneer ? '100%' :
    (props.isFull && (props.isTheLast || props.sessionStatus === 'noBegin' || props.sessionStatus === 'end')) ?
        '100%' : 'calc(100% - 0.48rem)'};
  i.fullOpt, i.outOpt {
    position: absolute;
    bottom: 0.24rem;
    right: 0.24rem;
    width: 0.4rem;
    height: 0.4rem;
    cursor: pointer;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position:center;
  }
  i.fullOpt {
    background-image: ${`url(${require('@/assets/Screen/icon_notFull@3x.png')})`};
  }
  i.outOpt {
    background-image: ${`url(${require('@/assets/Screen/icon_full@3x.png')})`};
  }
  .first_space {
    height: ${(props) => {
    return props.isAuctioneer ? '0.22rem' : '0.4rem';
}};
  }
  .second_space {
    height: ${(props) => props.isAuctioneer ? '0.24rem' : '0.26rem'};
  }
`;
export const Tag = styled.div `
  display: flex;
  border-radius: 4px;
  border: 1px solid;
  padding: 0 0.07rem;
  font-size: 0.22rem;
  height: 0.32rem;
  /* 解决大屏不垂直居中 */
  line-height: 0.28rem;
`;
export const Line = styled.div `
  margin-right: ${(props) => props.isAuctioneer ? '0.16rem' : '0.24rem'};
  width: ${(props) => props.isAuctioneer ? 'calc(100% - 0.16rem)' : 'calc(100% - 0.24rem)'};
	height: 0;
	border-bottom: solid 2px #ffffff;
`;
export const Root = styled(TextCenter) `
  padding: ${(props) => props.isAuctioneer ? '0.32rem 0.24rem' : '0.32rem 0.4rem'};
  width: 100%;
  height: 100%;
  background-color: #000537;
  .carInfo_2 {
    padding: 0;
    background: transparent;
    border-radius: 0;
    .content {
      padding: 0;
      overflow-x: hidden;
    }
    .ant-row {
      display:flex;
      justify-content: flex-start;
      margin: 0;
      text-align: left;
    }
    .col__key {
      color: #fff!important;
    }
    .ant-col-7 {
      width: 37.5%;
    }
    .ant-col-4 {
      width: auto;
    }
    .ant-col-3 {
      width: 1.1rem;
    }
  }
  .carInfo_2.L {
    .ant-row {
      height: 0.2rem;
      margin-bottom: 0.12rem;
      .ant-col {
        height: 0.2rem;
        line-height: 0.2rem;
        font-size: 0.18rem;
      }
      .col__key {
        margin-right: 0.12rem;
      }
    }
  }
  .carInfo_2.B {
    .ant-row {
      height: 0.22rem;
      margin-bottom: 0.16rem;
      .ant-col {
        height: 0.22rem;
        line-height: 0.22rem;
        font-size: 0.22rem;
      }
    }
    .col__value {
      width: 24%;
    }
  }
  .s--top {
    font-size: ${(props) => props.isAuctioneer ? '0.28rem' : '0.44rem'};
    .btn_carNum {
      width: ${(props) => props.isAuctioneer ? '0.76rem' : '1.2rem'};
      height: ${(props) => props.isAuctioneer ? '0.48rem' : '0.64rem'};
      border-radius: 0.08rem;
	    border: solid 2px #ffee00;
      color: #ffee00;
      font-size: ${(props) => props.isAuctioneer ? '0.28rem' : '0.44rem'};
      background-color: transparent;
      /* 解决大屏不垂直居中 */
      line-height: 0;
    }
    .top__carName {
      text-align: left;
      margin-left: 0.16rem;
      line-height: ${(props) => props.isAuctioneer ? '0.34rem' : '0.5rem'};
    }
  }
  .s--center {
    width: 100%;
    height: ${(props) => props.isAuctioneer ?
    'calc(100% - 2.3rem)' : 'calc(100% - 2.54rem)'};
    .center-left {
      position: relative;
      width: ${(props) => props.isAuctioneer ? '49.4%' : '46.8%'};
      height: 100%;
      .carLevel {
        position: absolute;
        padding: ${(props) => props.isAuctioneer ? '0.04rem 0.07rem 0 0.12rem' : '0.07rem 0.15rem 0 0.2rem'};
        right: 0;
        bottom: 0;
        z-index: 11;
        color: #000;
        font-size: ${(props) => props.isAuctioneer ? '0.16rem' : '0.32rem'};
        &::before{
          content: '';
          position: absolute;
          top:0;left:0;right:0;bottom:1px;
          z-index: -1;
          background-image: linear-gradient(137deg, #ffd910 0%, #ffb811 100%);
          transform: perspective(.5em) rotateX(2deg);
          transform-origin: bottom right;
        }
      }
    }
    .center-right {
      position: relative;
      padding-left: ${(props) => props.isAuctioneer ? '0.16rem' : '0.24rem'};
      width: ${(props) => props.isAuctioneer ? '50.6%' : '53.2%'};
      height: 100%;
      background-color: #01205c;
	    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
      .center_content {
        position: relative;
        width: 100%;
        height: 100%;
        .r-bidS__container {
          margin-bottom: ${(props) => props.isAuctioneer ? '0.15rem' : '0'};
          /* 竞拍状态 */
          .r-bidS {
            margin-right: 0.16rem;
            padding: ${(props) => props.isAuctioneer ? '0.04rem 0.08rem' : '0.06rem 0.12rem'};
            /* font-size: ${(props) => props.isAuctioneer ? '0.16rem' : '0.24rem'}; */
            /* line-height: ${(props) => props.isAuctioneer ? '0.16rem' : '0.24rem'}; */
            /* ceshi */
            font-size: ${(props) => props.isAuctioneer ? '0.18rem' : '0.24rem'};
            line-height: ${(props) => props.isAuctioneer ? '0.18rem' : '0.24rem'};
            border-radius: 0.04rem;
          }
          /* 黄色竞拍状态 */
          .r-bidS.bidStatus--yellow {
            color: #1a1a1a;
            background-color: #ffee00;
          }
          /* 灰色竞拍状态 */
          .r-bidS.bidStatus--grey {
            color: #ffffff;
            background-color: #999999;
          }
          /* 价格描述 */
          .r-bidS__desc {
            font-size: ${(props) => props.isAuctioneer ? '0.18rem' : '0.28rem'};
            color: #ffffff;
          }
        }
        /* 价格区域 */
        .r-p {
          width: 100%;
          text-align: left;
          max-height: ${(props) => props.isAuctioneer ? '1.8rem' : '2.8rem'};;
          /* 标签 出价类型领先|与保留价关系|与暗拍价关系  */
          .r-priceS {
            height: ${(props) => props.isAuctioneer ? '0.2rem' : '0.9rem'};
          }
          /* 当前价等 */
          .r-currentPrice {
            height: ${(props) => props.isAuctioneer ? '1.4rem' : '1.5rem'};
            line-height: 1;
          }
          .r-priceC {
            /* font-size: ${(props) => props.isAuctioneer ? '0.88rem' : '1.48rem'}; */
            /* line-height: ${(props) => props.isAuctioneer ? '0.98rem' : '1.48rem'}; */
            /* ceshi */
            font-size: ${(props) => props.isAuctioneer ? '1rem' : '1.08rem'};
            /* line-height: ${(props) => props.isAuctioneer ? '1.4rem' : '1.48rem'}; */
            color: #ffffff;
          }
          /* 红灯 */
          .r-priceC.price--red {
            color: #ff4040;
          }
          /* 绿灯 */
          .r-priceC.price--green {
            color: #1dbf6e;
          }
          /* 黄灯 */
          .r-priceC.price--yellow {
            color: #ffee00;
          }
          /* 当前价等单位 */
          .r-priceC__desc {
            margin-right: ${(props) => props.isAuctioneer ? '0.16rem' : '0.24rem'};
            font-size: ${(props) => props.isAuctioneer ? '0.2rem' : '0.25rem'};
            /* line-height: ${(props) => props.isAuctioneer ? '0.55rem' : '0.75rem'}; */
            color: #ffffff;
          }
          /* 合手价 佣金 服务费 */
          .getPrices {
            width: 100%;
            /* height: ${(props) => props.isAuctioneer ? '0.4rem' : '0.6rem'}; */
            /* ceshi */
            height: ${(props) => props.isAuctioneer ? '0.6rem' : '0.6rem'};
            .r-priceH {
              /* font-size: ${(props) => props.isAuctioneer ? '0.2rem' : '0.32rem'};
              line-height: ${(props) => props.isAuctioneer ? '0.2rem' : '0.32rem'}; */
              /* ceshi */
              font-size: ${(props) => {
    return props.isAuctioneer ? '0.2rem' :
        props.isFull && props.isFourToThree ? props.isTheLast ? '0.2rem' : '0.16rem' : // 不是最后一辆车待定
            props.isTheLast ? '0.25rem' : '0.26rem';
}};
              line-height: ${(props) => {
    return props.isAuctioneer ? '0.2rem' : props.isTheLast ? '0.28rem' : '0.30rem';
}};
            }
            .r-priceYF {
              /* font-size: ${(props) => props.isAuctioneer ? '0.14rem' : '0.24rem'};
              line-height: ${(props) => props.isAuctioneer ? '0.2rem' : '0.32rem'}; */
              /* ceshi */
              font-size: ${(props) => {
    return props.isAuctioneer ? '0.14rem' :
        props.isFull && props.isFourToThree ? props.isTheLast ? '0.16rem' : '0.16rem' : // 不是最后一辆车待定
            props.isTheLast ? '0.17rem' : '0.19rem';
}};
              line-height: ${(props) => {
    return props.isAuctioneer ? '0.2rem' : props.isTheLast ? '0.28rem' : '0.3rem';
}};
            }
          }
        }
      }
    }
    .center-right.style--deal__tender, .center-right.style--deal__scence, .center-right.style--deal__net,
    .center-right.style--waitDeal, .center-right.style--abortive {
      .resultIcon {
        position: absolute;
        bottom: ${(props) => props.isAuctioneer ? '0.12rem' : '0.4rem'};
        right: ${(props) => props.isAuctioneer ? '0.12rem' : '0.4rem'};
        z-index: 10;
        display: inline-block;
        width: ${(props) => props.isAuctioneer ? '1.2rem' : '2rem'};
        height: ${(props) => props.isAuctioneer ? '1.2rem' : '2rem'};
        cursor: pointer;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position:center;
      }
    }
    /* 成交状态下的样式 */
    /* 投标成交 */
    .center-right.style--deal__tender{
      .resultIcon {
        background-image: ${`url(${require('@/assets/Screen/icon_deal__tender@3x.png')})`};
      }
    }
    /* 竞拍现场成交 */
    .center-right.style--deal__scence{
      .resultIcon {
        background-image: ${`url(${require('@/assets/Screen/icon_deal__scence@3x.png')})`};
      }
    }
    /* 竞拍远程成交 */
    .center-right.style--deal__net{
      .resultIcon {
        background-image: ${`url(${require('@/assets/Screen/icon_deal__net@3x.png')})`};
      }
    }
    /* 待成交状态下的样式 */
    .center-right.style--waitDeal{
      .resultIcon {
        background-image: ${`url(${require('@/assets/Screen/icon_waitDeal@3x.png')})`};
      }
    }
    /* 流拍状态下的样式 */
    .center-right.style--abortive{
      .resultIcon {
        background-image: ${`url(${require('@/assets/Screen/icon_abort@3x.png')})`};
      }
    }
    /* 红灯 */
    .r-priceC.style--red span {
      color: #ff4040;
    }
    /* 绿灯 */
    .r-priceC.style--green span{
      color: #1dbf6e;
    }
    /* 黄灯 */
    .r-priceC.style--yellow span{
      color: #ffee00;
    }

  }
`;
